export enum SignaturesConstants {
  SET_ACKNOWLEDGE_PRIVACY_NOTICE = 'signatures/SET_ACKNOWLEDGE_PRIVACY_NOTICE',
  SET_SIGNATURE_SECTION = 'signatures/SET_SIGNATURE_SECTION',
  SET_RESPONSE = 'signatures/SET_RESPONSE',
  SET_PATIENT_SIGNATURE = 'signatures/SET_PATIENT_SIGNATURE',
  SET_IS_MARK = 'signatures/SET_IS_MARK',
  SET_WITNESS_SIGNATURE = 'signatures/SET_WITNESS_SIGNATURE',
  SET_AMBULANCE_CREW_SIGNATURE = 'signatures/SET_AMBULANCE_CREW_SIGNATURE',
  SET_REPRESENTATIVE_SIGNATURE = 'signatures/SET_REPRESENTATIVE_SIGNATURE',
  SET_RECIEVING_FACILITY_SIGNATURE = 'signatures/SET_RECIEVING_FACILITY_SIGNATURE',
  SET_CREW_SIGNATURE = 'signatures/SET_CREW_SIGNATURE',
  SET_SELECTED_SIGNATURE_TYPE = 'signatures/SET_SELECTED_SIGNATURE_TYPE',
  SAVE_SIGNATURES = 'signatures/SAVE_SIGNATURES',
  SAVE_ATTACHMENT = 'signatures/SAVE_ATTACHMENT',
  DELETE_SIGNATURE_TYPE = 'signatures/DELETE_SIGNATURE_TYPE',
  SAVE_TEMP_SIGNATURE = 'signatures/SAVE_TEMP_SIGNATURE',
  CLEAR_TEMP_SIGNATURE = 'signatures/CLEAR_TEMP_SIGNATURE',
  GET_SIGNATURES = 'signatures/GET_SIGNATURES',
  RESET_STATE = 'signatures/RESET_STATE',
  DELETE_ATTACHMENT = 'signatures/DELETE_ATTACHMENT',
  SET_ATTACHMENTS_LIST = 'signatures/SET_ATTACHMENTS_LIST',
  GET_ATTACHMENTS = 'signatures/GET_ATTACHMENTS',
  SHOW_CONFIRMATION_ALERT = 'signatures/SHOW_CONFIRMATION_ALERT',
  CLEAR_ATTACHMENTS = 'signatures/CLEAR_ATTACHMENTS',
  PATIENT = 'Patient',
  WITNESS = 'Witness',
  AMBULANCE = 'Ambulance',
  REPRESENTATIVE = 'Representative',
  CREW = 'Crew',
  RECEIVING = 'Receiving',
  SET_FILE_NAME = 'signatures/SET_FILE_NAME',
  SET_PATIENT_PRINTED_NAME = 'signatures/SET_PATIENT_PRINTED_NAME',
  SET_WITNESS_PRINTED_NAME = 'signatures/SET_WITNESS_PRINTED_NAME',
  SET_WITNESS_PHONE = 'signatures/SET_WITNESS_PHONE',
  SET_WITNESS_ADDRESS = 'signatures/SET_WITNESS_ADDRESS',
  SET_AMBULANCE_PRINTED_NAME = 'signatures/SET_AMBULANCE_PRINTED_NAME',
  SET_REPRESENTATIVE_PRINTED_NAME = 'signatures/SET_REPRESENTATIVE_PRINTED_NAME',
  SET_REPRESENTATIVE_PHONE = 'signatures/SET_REPRESENTATIVE_PHONE',
  SET_REPRESENTATIVE_ADDRESS = 'signatures/SET_REPRESENTATIVE_ADDRESS',
  SET_RECEIVING_FACILITY_PRINTED_NAME = 'signatures/SET_RECEIVING_FACILITY_PRINTED_NAME',
  SET_CREW = 'signatures/SET_CREW',
  SET_SECTION_TWO_REASON_INCAPABLE_OF_SIGNING = 'signatures/SET_SECTION_TWO_REASON_INCAPABLE_OF_SIGNING',
  SET_SECTION_TWO_SELECTED_OPTION_INCAPABLE_OF_SIGNING = 'signatures/SET_SECTION_TWO_SELECTED_OPTION_INCAPABLE_OF_SIGNING',
  SET_SECTION_TWO_AUTHORIZED_REPRESENTATIVE = 'signatures/SET_SECTION_TWO_AUTHORIZED_REPRESENTATIVE',
  SET_SECTION_THREE_REASON_INCAPABLE_OF_SIGNING = 'signatures/SET_SECTION_THREE_REASON_INCAPABLE_OF_SIGNING',
  SET_SECTION_THREE_SELECTED_OPTION_INCAPABLE_OF_SIGNING = 'signatures/SET_SECTION_THREE_SELECTED_OPTION_INCAPABLE_OF_SIGNING',
  SAVE_SIGNATURES_PCR = 'signatures/SAVE_SIGNATURES_PCR',
  SET_SIGNATURES = 'signatures/SET_SIGNATURES',
  SAVE_SIGNATURE_ON_CLICK = 'signatures/SAVE_SIGNATURE_ON_CLICK',
  SET_IS_SECTION_LOCKED_FLAG = 'signatures/SET_IS_SECTION_LOCKED_FLAG',
  CLEAR_SIGNATURE_STATE = 'signatures/CLEAR_SIGNATURE_STATE',
  DELETE_ALL_SIGNATURE_DATA = 'signatures/DELETE_ALL_SIGNATURE_DATA',
  SET_RECEIVING_FACILITY_TITLE = 'signatures/SET_RECEIVING_FACILITY_TITLE',
  CLEAR_SIGNATURE_SECTION_ON_CLICK = 'signatures/CLEAR_SIGNATURE_SECTION_ON_CLICK',
  SET_AMBULANCE_SIGNATURE_DT = 'signatures/SET_AMBULANCE_SIGNATURE_DT',
  SET_PATIENT_SIGNATURE_DT = 'signatures/SET_PATIENT_SIGNATURE_DT',
  SET_WITNESS_SIGNATURE_DT = 'signatures/SET_WITNESS_SIGNATURE_DT',
  SET_REPRESENTATIVE_SIGNATURE_DT = 'signatures/SET_REPRESENTATIVE_SIGNATURE_DT',
  SET_CREW_SIGNATURE_DT = 'signatures/SET_CREW_SIGNATURE_DT',
  SET_RECEIVING_FACILITY_SIGNATURE_DT = 'signatures/SET_RECEIVING_FACILITY_SIGNATURE_DT',
  SET_SELECTED_CHECKBOX = 'signatures/SET_SELECTED_CHECKBOX',
  SET_UPDATED_ACKNOWLEDGEMENT = 'signatures/SET_UPDATED_ACKNOWLEDGEMENT',
  SET_UPDATED_TERMS = 'signatures/SET_UPDATED_TERMS',
  SET_SIGNATURE_CHIP = 'signatures/SET_SIGNATURE_CHIP',
  LOAD_SIGNATURE_DATA = 'signatures/LOAD_SIGNATURE_DATA',
  SHOW_ATTACHMENTS = 'signatures/SHOW_ATTACHMENTS',
  CLEAR_SIGNATURE_TEMP_STATE = 'signatures/CLEAR_SIGNATURE_TEMP_STATE',
  SET_SECTION_I_HEADERTEXT = 'signatures/SET_SECTION_I_HEADERTEXT',
  SET_SECTION_II_HEADERTEXT = 'signatures/SET_SECTION_II_HEADERTEXT',
  SET_SECTION_III_HEADERTEXT = 'signatures/SET_SECTION_III_HEADERTEXT',
  CLEAR_SIGNATURE_DATA = 'signatures/CLEAR_SIGNATURE_DATA',
  SAVE_SIGNATURE_CHIPS_DATA = 'signatures/SAVE_SIGNATURE_CHIPS_DATA',
  AMBULANCE_CREW_SIGNATURE = 'Ambulance Crew Signature',
}
